import classnames from "classnames"
import styles from "./ExhibitionsBig.module.css"
import Link from "next/link"
import { Row, Col } from "react-bootstrap"
import { ButtonCta } from "../Layout/ButtonCta"

const ExhibitionCard = (props) => {
  const {
    id,
    description,
    image,
    date,
    name,
    href,
    to,
    cta,
    author,
    titleHeader,
  } = props

  return (
    <div
      className={styles.exhibitions}
      style={{ backgroundImage: `url(${image})` }}>
      <div className={styles.exhibitionInfo}>
        <Row className="h-100">
          <Col className="d-flex justify-content-center justify-content-lg-start">
            <div className={styles.bottom}>
              <h2 className="color-white fs-12px fw-300 mb-0">{titleHeader}</h2>
              <h1 className="color-white fs-36px fw-300 mb-0">{name}</h1>
              <span className="fs-14px color-white font-primary">{author}</span>
            </div>
          </Col>
          <Col
            xs={12}
            lg={4}
            className="d-flex justify-content-center justify-content-lg-end">
            <div className={styles.bottom}>
              <Link href={href} as={to}>
                <ButtonCta title={cta} />
              </Link>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}
export default ExhibitionCard
